import type { HeadingLevelProps } from '../../GridDndEditor/TiptapEditor/TipTapBarMenu/Heading.tsx';

export const DEFAULT_FONT_FAMILY = 'Plus Jakarta Sans';
export const DEFAULT_LINE_HEIGHT = 'normal';
export const DEFAULT_SIZE = '12';
interface FontSizeOption {
  name: string;
  value: string;
}

export const DEFAULT_FONT_SIZES: FontSizeOption[] = [
  { name: '8', value: '8px' },
  { name: '9', value: '9px' },
  { name: '10', value: '10px' },
  { name: DEFAULT_SIZE, value: `${DEFAULT_SIZE}px` },
  { name: '14', value: '14px' },
  { name: '16', value: '16px' },
  { name: '18', value: '18px' },
  { name: '24', value: '24px' },
  { name: '30', value: '30px' },
  { name: '32', value: '32px' },
  { name: '42', value: '42px' },
];

interface LineHeightOption {
  name: string;
  level: string;
}

export const DEFAULT_LINE_HEIGHT_OPTIONS: LineHeightOption[] = [
  { name: 'Default', level: DEFAULT_LINE_HEIGHT },
  { name: 'Single', level: '1.2' },
  { name: '1.15', level: '1.38' },
  { name: '1.5', level: '1.799' },
  { name: 'Double', level: '2.4' },
];

export const HEADING_FONT_SIZES: Record<number, string> = {
  1: '42',
  2: '32',
  3: '24',
  4: '18',
} as const;

export interface FontFamilyOption {
  name: string;
}
interface DownloadedFontFamilyOption {
  name: string;
  path: string;
}

export const DEFAULT_FONT_FAMILY_OPTIONS: FontFamilyOption[] = [
  { name: 'Arial' },
  { name: 'Georgia' },
  { name: 'Roboto' },
  { name: 'Times New Roman' },
];

export const DOWNLOADED_FONTS: DownloadedFontFamilyOption[] = [
  { name: DEFAULT_FONT_FAMILY, path: 'PlusJakartaSans' },
  { name: 'Zilla Slab', path: 'Zilla_Slab' },
  { name: 'Nunito', path: 'Nunito' },
  { name: 'Merriweather', path: 'Merriweather' },
  { name: 'Poppins', path: 'Poppins' },
  { name: 'Bebas Neue', path: 'Bebas_Neue' },
  { name: 'Lora', path: 'Lora' },
  { name: 'Work Sans', path: 'Work_Sans' },
  { name: 'Manrope', path: 'Manrope' },
];

export const ALL_FONT_FAMILY_OPTIONS: FontFamilyOption[] = [...DEFAULT_FONT_FAMILY_OPTIONS, ...DOWNLOADED_FONTS];

export const DEFAULT_TABLE_FONT_SIZE = '14';
export const DEFAULT_DROP_DOWN_FONT_SIZE = '16';

export const normalTextLevel: Record<string, Partial<HeadingLevelProps>> = {
  normalText: {
    fontSize: HEADING_FONT_SIZES[1],
    title: 'editor.toolbar.normal_text',
    isFontWeightBold: false,
  },
};

export const PARAGRAPH_INITIAL_LEVEL = 'normalText';

export const headingTextLevels: Record<string, HeadingLevelProps> = {
  h1: {
    fontSize: HEADING_FONT_SIZES[1],
    title: 'editor.toolbar.heading_1',
    isFontWeightBold: true,
    dataAttribute: 'h1',
    level: 1,
  },
  h2: {
    fontSize: HEADING_FONT_SIZES[2],
    title: 'editor.toolbar.heading_2',
    isFontWeightBold: true,
    dataAttribute: 'h2',
    level: 2,
  },
  h3: {
    fontSize: HEADING_FONT_SIZES[3],
    title: 'editor.toolbar.heading_3',
    isFontWeightBold: true,
    dataAttribute: 'h3',
    level: 3,
  },
  h4: {
    fontSize: HEADING_FONT_SIZES[4],
    title: 'editor.toolbar.heading_4',
    isFontWeightBold: false,
    dataAttribute: 'h4',
    level: 4,
  },
};
